import React, { Dispatch, FC, SetStateAction, useState } from "react"
import { Order, Stats } from "@/lib/types"
import { convertEquipmentType, dateFormat1, dollarUS } from "@/lib/services"
import { Table } from "@/components/general/Table"
import { Tabs } from "@/components/general/Tabs"

type Props = {
  header: {
    name: string
    width: string
  }[]
  deliveriesListingData: { deliveries: Order[] }
  recentQuoteslistingData: { quotes: Order[] }
  defaultVal: Stats
  setStat: Dispatch<SetStateAction<Stats>>
}

const tabs = [
  {
    identifier: "quotes",
    name: "Quotes",
  },
  {
    identifier: "tendered",
    name: "Order Confirmations",
  },
]

export const AdminTable: FC<Props> = (props) => {
  const [id, setId] = useState("")
  const [selectedTab, setSelectedTab] = useState("quotes")

  return (
    <>
      <div className="py-5">
        <Tabs
          selectTab={setSelectedTab}
          tabs={tabs}
          selectedTab={selectedTab}
        />
      </div>
      {selectedTab == "quotes" ? (
        <Table
          header={props.header.filter(
            (items) =>
              items.name !== "Delivery Date" &&
              items.name !== "Action" &&
              items.name !== "Method",
          )}
          headerAlign="text-left"
          lastheadingAlign="text-right"
        >
          {props.recentQuoteslistingData.quotes.map((e: Order, i: number) => (
            <tr
              key={i}
              className={
                (e.id == id
                  ? " bg-primary-8 dark:text-secondary-2 text-primary-1"
                  : "dark:text-primary-10") +
                " text-sm cursor-pointer border-b-2 dark:border-secondary-11 text-left"
              }
              onClick={() => setId(e.id)}
            >
              <td className="whitespace-nowrap p-4 w-28">
                {dateFormat1(e.createdAt)}
              </td>
              <td className="whitespace-nowrap p-4 w-52">
                {e.user.firstName} {e.user.lastName}
              </td>
              <td className="whitespace-nowrap p-4 w-64 truncate">
                {e.origin}
              </td>
              <td className="whitespace-nowrap p-4 w-64 truncate">
                {e.destination}
              </td>
              <td className="whitespace-nowrap p-4 w-40">
                {convertEquipmentType(e.equipment)}
              </td>
              <td className="whitespace-nowrap p-4 w-44">
                {dateFormat1(e.pickupDate)}
              </td>
              <td className="whitespace-nowrap p-4 w-28">
                {dollarUS.format(e.cost)}
              </td>
              <td className="whitespace-nowrap text-right p-4 w-28">
                {dollarUS.format(e.price)}
              </td>
            </tr>
          ))}
        </Table>
      ) : selectedTab == "tendered" ? (
        <Table
          header={props.header.filter((a) => a.name !== "Action")}
          headerAlign="text-left"
          lastheadingAlign="text-right"
        >
          {props.deliveriesListingData.deliveries.map((e: Order, i: number) => (
            <tr
              key={i}
              className={
                (e.id == id
                  ? " bg-primary-8 dark:text-secondary-2"
                  : "dark:text-primary-10") +
                " text-sm cursor-pointer border-b-2 dark:border-secondary-11 text-left"
              }
              onClick={() => setId(e.id)}
            >
              <td className="whitespace-nowrap p-4 w-28">
                {dateFormat1(e.createdAt)}
              </td>
              <td className="whitespace-nowrap p-4 w-52">
                {e.user.firstName} {e.user.lastName}
              </td>
              <td className="whitespace-nowrap p-4 w-64 truncate">
                {e.origin}
              </td>
              <td className="whitespace-nowrap p-4 w-64 truncate">
                {e.destination}
              </td>
              <td className="whitespace-nowrap p-4 w-40">
                {convertEquipmentType(e.equipment)}
              </td>
              <td className="whitespace-nowrap p-4 w-44">
                {dateFormat1(e.pickupDate)}
              </td>
              <td className="whitespace-nowrap p-4 w-44">
                {dateFormat1(e.deliveryDate)}
              </td>
              {/* <td className="whitespace-nowrap p-4 w-36">{e.method}</td> */}
              <td className="whitespace-nowrap p-4 w-36">
                {{
                  transloadRates: "Transload",
                  directRates: "Direct",
                  domesticRates: "Domestic",
                  standardRates: "Standard",
                }[e.method ?? ""] || e.method}
              </td>
              <td className="whitespace-nowrap p-4 w-28">
                {dollarUS.format(e.cost)}
              </td>
              <td className="whitespace-nowrap text-right p-4 w-28">
                {dollarUS.format(e.price)}
              </td>
            </tr>
          ))}
        </Table>
      ) : null}
    </>
  )
}
